import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const core = (state: RootState) => state.core;

export const serviceConfig = createSelector(core, state => state.serviceUrls);
export const currentUrl = createSelector(core, state => state.currentUrl);
export const tenant = createSelector(core, state => state.tenant);
export const locale = createSelector(core, state => state.locale);
export const currency = createSelector(core, state => state.currency);
export const brandColour = createSelector(core, state => state.brandColour);
export const logoSrc = createSelector(core, state => state.logoSrc);

export const featureFlags = createSelector(core, state => state.featureFlags);

export const modelError = createSelector(core, state => state.error?.context.type === 'model');

export const renderError = createSelector(core, state => state.error?.context.type === 'render');

export const logLevel = createSelector(core, state => state.logLevel);

export const environment = createSelector(core, state => state.environment);

export const sentryDsn = createSelector(core, state => state.sentryDsn);

export const measurementUnit = createSelector(core, state => state.measurementUnit);
